import { Button } from "@/ui/button";
import { Modal } from "@/ui/modals";
import { useWeb3Auth } from "@web3auth/modal-react-hooks";
import { ReactNode } from "react";
import { removeUserId } from "@/helpers/localStorage.ts";

const WalletSettingsModal = ({
  opened = true,
  onClose,
  onConfirm,
  children,
}: {
  opened?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  children: ReactNode;
}) => {
  const { logout } = useWeb3Auth();
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size="auto"
      className="py-[0.9375rem] px-[0.6250rem]"
    >
      <Modal.Title title="Settings" className="text-sm font-semibold" />
      {children}
      <Modal.Footer>
        <Button
          title="Done"
          onClick={onConfirm}
          className="w-[9.4375rem] text-xs font-semibold"
          active={false}
        />
        <Button
          title="Sign Out"
          onClick={() => {
            logout();
            removeUserId();
            onClose();
          }}
          className="w-[9.4375rem] text-xs font-semibold"
          active={false}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default WalletSettingsModal;
